import { ClientType } from './client-type.model';
import { ComplaintAddress } from '../complaint/complaint-address.model';
import { CreditLineFNB } from './credit-line-fnb.model';

/**Información básica de cuenta */
export class AccountBasicData {
    /**Nombres */
    public name: string;
    /**Apellidos */
    public lastName: string;
    /**Dirección de suministro */
    public supplyAddress: ComplaintAddress;
    /**Dirección postal */
    public postalAddress: ComplaintAddress;
    /**Dirección de correo electrónico */
    public emailAddress: string;
    /**Teléfono fijo */
    public homePhoneNumber: string;
    /**Celular */
    public cellPhoneNumber: string;
    /**Código de tipo de cliente */
    public clientTypeCode: string;
    /**Tipo de documento */
    public documentType: string;
    /**Número de documento */
    public documentNumber: string;
    /**Código de cliente */
    public clientCode: string;
    /**Id de interlocutor */
    public interlocutorId: string;
    /**Giro de negocio */
    public businessField: string;
    /**Número de instalación */
    public installationNumber: string;
    /**Número de puntos de gas */
    public installationCount: string;
    /**Lugar de instalación */
    public installationType: string;
    /**Línea de crédito disponible */
    public availableCreditLineAmount: number;
    /**Tipo de cliente */
    public clientType: ClientType;
    public creditLineFNB: CreditLineFNB;

    public dirsum:string;

    public tieneDirSuministro:boolean;
}